import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import RevealText from "../components/shared/RevealText";
import Eyebrow from "../components/shared/Eyebrow";
import WhatsAppButton from "../components/shared/WhatsAppButton";

export default function NotFound() {
  return (
    <section className="min-h-screen bg-ink text-white flex items-center pt-24 pb-16">
      <div className="container-emilio grid grid-cols-1 lg:grid-cols-12 items-center gap-10">
        <div className="lg:col-span-6">
          <Eyebrow>404 — Not Found</Eyebrow>
          <RevealText
            as="h1"
            text={"Looks like this\npage was already\ncleaned away."}
            className="mt-6 font-display font-extrabold text-white text-hero"
          />
          <p className="mt-6 text-mutedtext text-base md:text-lg max-w-md leading-relaxed">
            The page you're looking for doesn't exist or has been moved.
            Try our services or say hello on WhatsApp.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <WhatsAppButton label="Chat on WhatsApp" />
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-emerald font-semibold text-sm hover:gap-3 transition-all"
            >
              Back to Home <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
        <div className="lg:col-span-6">
          <div className="font-display font-extrabold text-colossal text-charcoal leading-[0.85] select-none">
            404
          </div>
        </div>
      </div>
    </section>
  );
}
